import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { store } from '@/store'
import { setCredentials } from '@/store/authSlice'
import { restoreUserFromSession, getStoredToken } from '@/lib/auth'
import { ThemeWrapper } from '@/lib/ThemeWrapper'
import App from './App.tsx'
import './index.css'

// Hydrate Redux auth state from sessionStorage so a page refresh keeps the
// user logged in without flashing the login page.
const restoredToken = getStoredToken()
const restoredUser = restoreUserFromSession()
if (restoredToken && restoredUser) {
  store.dispatch(setCredentials({ user: restoredUser, token: restoredToken }))
}

const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <StrictMode>
    <Provider store={store}>
      <ThemeWrapper>
        <App />
      </ThemeWrapper>
    </Provider>
  </StrictMode>
)
